import { useLayoutEffect, useRef } from 'react';

interface Props {
  text: string;
}
const Description = (props: Props) => {
  const { text } = props;
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (!ref.current) {
      return;
    }
    const link = ref.current.querySelectorAll('a');
    link.forEach((el) => {
      // eslint-disable-next-line no-param-reassign
      el.onclick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        const href = el.getAttribute('href');
        if (href) {
          window.open(href);
        }
      };
    });
  }, [text]);

  // eslint-disable-next-line react/no-danger
  return <div ref={ref} dangerouslySetInnerHTML={{ __html: text }} />;
};

export default Description;
